import {AssetParent} from "./asset_Parent";

export class ImageAsset extends AssetParent {

    folderName = "Images"


}